function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var pcsFormValues = new ( /*#__PURE__*/function () {
  function PcsFormValues() {
    var _this = this;
    _classCallCheck(this, PcsFormValues);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(PcsFormValues, [{
    key: "init",
    value: function init() {
      $(document).on('click', '[data-action="add-entry"]', this.onAddEntry.bind(this));
      $(document).on('click', '[data-action="del-entry"]', this.onDeleteEntry.bind(this));
      $(document).on('click', '[data-action="skip"]', this.onSkipClick.bind(this));
      $(document).on('submit', '.pcs-form-values', this.onSubmitValues.bind(this));
      vent.on('PCS:CHECK_FORM_UI', this.checkFormInterface.bind(this));
      vent.publish('PCS:CHECK_FORM_UI');
      vent.on('PCS:REFRESH_UI', function () {
        vent.publish('PCS:CHECK_FORM_UI');
      });
    }
  }, {
    key: "onAddEntry",
    value: function onAddEntry(e, quiet) {
      var $form = $('.pcs-page-form');
      var $fields = $form.find('.pcs-form-values__fields');
      var template = $form.find('.pcs-form-values-templates').html().replaceAll('__id', '__id_' + Math.random());
      $fields.append(template);
      if (quiet !== true) {
        vent.publish('PCS:CHECK_FORM_UI');
      }
    }
  }, {
    key: "onDeleteEntry",
    value: function onDeleteEntry(e) {
      var $fieldset = $(e.target).closest('.pcs-form-values-fieldset');
      $fieldset.remove();
      vent.publish('PCS:CHECK_FORM_UI');
    }
  }, {
    key: "onSkipClick",
    value: function onSkipClick(e) {
      var $form = $(e.target).closest('.pcs-form-values');
      $form.find('input[name="skip"]').val(1);
    }
  }, {
    key: "onSubmitValues",
    value: function onSubmitValues(e) {
      e.preventDefault();
      var invalids = $(e.target).find('*:invalid, [aria-invalid="true"], .is-error');
      if (invalids.length) {
        vent.publish('FLASH:SHOW', {
          flash: 'Un ou plusieurs champs semblent contenir des erreurs',
          error: true
        });
        return;
      }
      vent.publish('PCS:SUBMIT_FORM', {
        form: $(e.target),
        successCallback: function successCallback(response) {},
        errorCallback: function errorCallback(response) {}
      });
    }
  }, {
    key: "checkFormInterface",
    value: function checkFormInterface() {
      // $elt.closest('.pcs-page-form')
      var $fields = $('.pcs-form-values__fields > .pcs-form-values-fieldset');
      var $submit = $('.pcs-form-values button[data-action="submit"]');
      var $addEntry = $('.pcs-form-values button[data-action="add-entry"]');
      var $form = $('.pcs-form-values');
      if ($fields.length >= $form.data('min')) {
        $submit.removeAttr('disabled');
      } else {
        $submit.attr('disabled', 'disabled');
      }
      if (!$form.data('max')) {
        $addEntry.removeAttr('disabled');
      } else {
        if ($fields.length < $form.data('max')) {
          $addEntry.removeAttr('disabled');
        } else {
          $addEntry.attr('disabled', 'disabled');
        }
      }
      for (var i = 0; i < $form.data('keep'); i++) {
        $fields.eq(i).find('[data-action="del-entry"]').remove();
      }
    }
  }]);
  return PcsFormValues;
}())();